import { Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { formatDateTime } from "@bw/shared/utils";
import type { Schema } from "@bw/shared/types/generated";

export function TournamentParticipationSummary({
  presence,
  liveUrl,
  nextMatch,
  nextMatchUrl,
}: {
  presence?: Schema["TournamentParticipantPresence"] | null;
  liveUrl?: string | null;
  nextMatch?: Schema["TournamentParticipantMatch"] | null;
  nextMatchUrl?: string | null;
}) {
  return (
    <>
      {presence ? (
        <Typography variant="body2">
          {presence.state === "expected"
            ? "Not checked in"
            : presence.state.replaceAll("_", " ")}
        </Typography>
      ) : null}
      {liveUrl ? (
        <Button
          component={RouterLink}
          to={liveUrl}
          size="small"
          sx={{ alignSelf: "flex-start" }}
        >
          Tournament day
        </Button>
      ) : null}
      {nextMatch ? (
        <Stack spacing={0.5} sx={{ alignItems: "flex-start", pt: 1 }}>
          <Typography variant="subtitle2">Next match</Typography>
          <Typography variant="body2">
            {nextMatch.state.replaceAll("_", " ")}
          </Typography>
          {nextMatch.blockers?.map((blocker, index) => (
            <Typography
              key={`${blocker.code}:${index}`}
              variant="body2"
              color="warning.main"
            >
              {blocker.code.replaceAll("_", " ")}
            </Typography>
          ))}
          {nextMatch.scheduled_start_at ? (
            <>
              <Typography variant="body2">
                {formatDateTime(nextMatch.scheduled_start_at)}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Times shown in your device’s time zone.
              </Typography>
            </>
          ) : null}
          {nextMatch.court_label ? (
            <Typography variant="body2">{nextMatch.court_label}</Typography>
          ) : null}
          {nextMatch.opponents.map((opponent) => (
            <Typography key={opponent.handle} variant="body2">
              {opponent.display_name ?? opponent.handle}
            </Typography>
          ))}
          {nextMatchUrl && nextMatchUrl !== liveUrl ? (
            <Button component={RouterLink} to={nextMatchUrl} size="small">
              View live match
            </Button>
          ) : null}
        </Stack>
      ) : null}
    </>
  );
}
